import {getDrugItemFormDefaultValues, initializeDoseLimits} from '@/modules/drug-catalog/functions'
import {SupportiveMedicationFormSchema} from '@/modules/drug-catalog/supportive-medications/schemas'
import {SelectItem} from '@cypro/ui/components/form/select'
import {elementToArray} from '@cypro/ui/utils'
import {DrugCatalogItem} from '@cypro/engine/schema'

export function getSupportiveMedicationFormDefaultValues(
  substance: DrugCatalogItem | undefined
): SupportiveMedicationFormSchema {
  return {
    ...getDrugItemFormDefaultValues(substance),
    doseCalcMode: elementToArray(substance?.supportiveMedicationDetails?.doseCalcMode),
    doseUnitId: elementToArray(substance?.supportiveMedicationDetails?.doseUnitId),
    doseLimits: initializeDoseLimits(substance?.supportiveMedicationDetails?.doseLimits),
    roundingMode: elementToArray(substance?.supportiveMedicationDetails?.roundingMode),
    // 0 decimals is a valid precision; only an unset value falls back to the default
    precision: substance?.supportiveMedicationDetails?.dosePrecision ?? 2,
    overdosePreventionLevel: elementToArray(substance?.supportiveMedicationDetails?.overdosePreventionLevel),
    externalInformationLink: substance?.supportiveMedicationDetails?.externalInformationLink || '',
    machineId: '',
  }
}

export function mapSupportiveMedicationsToSelectItems(supportiveMedicationDrugs: DrugCatalogItem[]): SelectItem[] {
  return supportiveMedicationDrugs.map(s => ({value: s.id, label: s.name}))
}

export function isSupportiveMedicationDeletable(_substance: DrugCatalogItem) {
  // TODO: implement active substances v2
  // return !substance.tradeNames?.length
  return true
}
